
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAIconsMixin, RoutingMixin, VuetifyMixin } from '@/mixins';
import { BAEventModel } from '@/models/baEvent';
import { baEventApi } from '@/api/BAEventsApi';
import { AthleteProfileModel, TeamModel } from '@/models';
import { OrganizationModel } from '@/models/organization/OrganizationModel';
import { AgeGroupValues, AgeGroup, Under13AgeGroup, PaginatedResponse } from '@best-athletes/ba-types';
import { notificationStore } from '@/store';
import { athleteApi } from '@/api/AthleteApi';
import { ageGroupToAge } from '@/../types';
import { wait } from '@/helpers';

enum InviteOptions {
    athlete = 'Invite by Athlete',
    team = 'Invite by Team',
    organization = 'Invite by Organization',
    age = 'Invite by Age Group',

}
@Component
export default class BAEventShare extends Mixins(VuetifyMixin, BAIconsMixin, RoutingMixin) {
    @Prop({ required: true }) event: BAEventModel;
    @Prop({ type: Boolean }) icon;
    @Prop({ type: Boolean }) small;
    
    InviteOptions = InviteOptions;
    ageGroupToAge = ageGroupToAge;

    inviteOption: string = InviteOptions.athlete;
    inviteOptions: Array<InviteOptions> = [InviteOptions.athlete, InviteOptions.team, InviteOptions.organization, InviteOptions.age];

    athleteToInvite: AthleteProfileModel;
    loadingAthlete: boolean = false;
    loadedAthlete: boolean = false;

    teamToInvite: TeamModel;

    organizationToInvite: OrganizationModel;

    ageGroupToInvite: AgeGroup | Under13AgeGroup;
    loadingAgeGroup: boolean = false;
    loadedAgeGroup: boolean = false;

    showDialog: boolean = false;
    onEventInviteBegin() {
        this.showDialog = true;
    }
	onUpdateAthlete(athlete: AthleteProfileModel) {
        this.loadedAthlete = false;
        this.loadingAthlete = true;
		this.athleteToInvite = athlete;
        this.loadedAthlete = this.IsNotEmpty(this.athleteToInvite);
        this.loadingAthlete = false;
	}

	athletesToInvite: Array<AthleteProfileModel> = [];
    filterYear: number;
	async onUpdateAgeGroup(ageGroup: AgeGroup | Under13AgeGroup) {
        this.loadedAgeGroup = false;
        this.loadingAgeGroup = true;
		this.ageGroupToInvite = ageGroup;
        if( this.IsEmpty(ageGroup) ) {
            this.filterYear = undefined;
            this.athletesToInvite = [];
        } else {
            const now: Date = new Date();
            const year: number = now.getFullYear();
            this.filterYear = year - ageGroupToAge(this.ageGroupToInvite);

            // get athletes list
            const response: PaginatedResponse<AthleteProfileModel> = await athleteApi.queryAll({}, {});
            this.athletesToInvite = response.docs.filter(a => this.IsNotEmpty(a.birthDate) && (a.birthDate.getFullYear() === this.filterYear));
        }

        this.loadedAgeGroup = this.IsNotEmpty(this.ageGroupToInvite);
        this.loadingAgeGroup = false;
	}
	get AgeGroups(): Record<string, string>[] {
		return AgeGroupValues.map(ag => ({
			text: String(ag),
			value: String(ag),
		}))
	}

    onPreview() {
        this.gotoAthletePublicLink(this.event?.ShareLink);
    }
    onClose() {
        this.showDialog = false
    }
    get ShareURL(): string {
        return `${this.PublicAthleteLink}/${this.event?.ShareLink}`;
    }

    inProgress: boolean = false;
    async onInviteAgeGroup(ageGroup: AgeGroup | Under13AgeGroup) {
        if( this.IsEmpty(ageGroup) ) return;

        this.inProgress = true;
        notificationStore.pushSnackbarWarning({message: `Inviting ${this.athletesToInvite.length} athletes`});
        await wait(1000);
        for( const athlete of this.athletesToInvite ) {
            notificationStore.pushSnackbarWarning({message: `Sending invitation to ${athlete.FullName}`});
            await this.inviteAttendee(athlete.id);
            await wait(500);
        }

        this.onUpdateAgeGroup(undefined);
        this.inProgress = false;

        notificationStore.pushSnackbarSuccess({message: `Invited all ${this.ageGroupToInvite} athletes`})
    }
    async onInviteAthlete(athlete: AthleteProfileModel) {
        if( this.IsEmpty(athlete) ) return;
        
        this.inProgress = true;
        await this.inviteAttendee(athlete.id);
        notificationStore.pushSnackbarSuccess({message: `${athlete.FullName} invited to ${this.event?.name}`});
        
        this.onUpdateAthlete(undefined);
        this.inProgress = false;
    }

    async inviteAttendee(athleteId: string) {
        await baEventApi.inviteParticipant(this.event?.id, athleteId);
    }
}
